export default class SmoothScroll {
    constructor() {
        this.arrow = $('.anchor');
        this.setEventListeners();
    }

    setEventListeners() {
        this.arrow.on('click', (e) => this.scrollToPosition(e));
    }

    scrollToPosition(e) {
        e.preventDefault();
        let target = e.target.getAttribute('data-destination');
        $('html, body').stop().animate({
            scrollTop: $(target).offset().top - 50
        }, 1000);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/SmoothScroll.js